export class LoginServidor {

   matricula: string;
   senha: string;

}



// WEBPACK FOOTER //
// ./src/app/models/login-servidor.ts